export const addAwardeePlaceholder = 'Add Awardee...';
export const addNewSupplier = 'Award to non-DemandStar Supplier';
